import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const UsersTableRow = ({
    user,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(user.id);

    // جلب الأدوار
    const roles = user?.roles?.map(role => role.name).join(', ') || '-';

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, user.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* الاسم */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic
                    ? (user?.name?.ar || user?.name?.en || (typeof user?.name === 'string' ? user.name : '-'))
                    : (user?.name?.en || user?.name?.ar || (typeof user?.name === 'string' ? user.name : '-'))
                }
            </TableCell>

            {/* البريد الإلكتروني */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {user?.email || '-'}
            </TableCell>

            {/* الأدوار */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Chip
                    label={roles}
                    size="small"
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {user?.created_at ? dayjs(user.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, user)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default UsersTableRow;